import React, { useEffect, useState } from "react";
import success from "../Images/success-web.svg";
import failed from "../Images/faild-web.svg";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";
import { Frames, CardNumber, ExpiryDate, Cvv } from "frames-react";
import { payAgain_checkout } from "../api-nano";
import BeatLoader from "react-spinners/BeatLoader";

function FailedTransaction() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  
  const [state, setState] = useState(false);
  const [cardValid, setCardValid] = useState(false);
  const [paymentLoad, setPaymentLoad] = useState(false);
  const [msgAr, setMsgAr] = useState("");
  const [msgEn, setMsgEn] = useState("");
  const [errorMsgModel, setErrorMsgModel] = useState(false);
  
  const token = localStorage.getItem("token");
  const failType = localStorage.getItem("failType");
  const orderId = localStorage.getItem("orderId");

  // إذا كانت العملية ناجحة والمستخدم ينقر على تتبع الطلب
  function handleProceed() {
    if (orderId) {
      navigate(
        generatePath("/order-track/:id", {
          id: orderId,
        })
      );
    }
  }

  function payAgain(paymentToken) {
    if (!orderId) {
      setErrorMsgModel(true);
      setMsgAr("رقم الطلب غير موجود");
      setMsgEn("Order ID not found");
      setPaymentLoad(false);
      return;
    }

    setPaymentLoad(true);
    setErrorMsgModel(false);

    payAgain_checkout(token, paymentToken, orderId)
      .then((response) => {
        if (response.data?.url) {
          // إذا كان هناك رابط للتحويل
          window.location.href = response.data.url;
        } else if (response.data?.message === "warning" && 
                   response.data?.data === "This order has been paid.") {
          setErrorMsgModel(true);
          setMsgAr("لقد تم دفع هذا الطلب بالفعل");
          setMsgEn("This order has been paid.");
          setState(true); // تغيير الحالة إلى النجاح
        } else if (response.data?.message === "warning") {
          setErrorMsgModel(true);
          setMsgAr("حدث فشل في عملية الدفع ، برجاء المحاولة مرة أخرى");
          setMsgEn("Transaction has failed, please try again");
        } else if (response.data?.success) {
          setState(true); // نجاح الدفع
          if (failType !== "order") {
            setTimeout(() => {
              navigate("/profile/myWallet");
            }, 2000);
          }
        } else {
          setErrorMsgModel(true);
          setMsgAr("حدث خطأ غير متوقع");
          setMsgEn("An unexpected error occurred");
        }
      })
      .catch((error) => {
        console.error("Payment error:", error);
        setErrorMsgModel(true);
        setMsgAr("حدث فشل في عملية الدفع ، برجاء المحاولة مرة أخرى");
        setMsgEn("Transaction has failed, please try again");
      })
      .finally(() => {
        setPaymentLoad(false);
        Frames.init(); // إعادة تهيئة إطار الدفع
      });
  }

  // إعادة التوجيه إذا لم يكن هناك orderId
  useEffect(() => {
    if (!orderId && failType === "order") {
      navigate("/");
    }
  }, [orderId, failType, navigate]);

  return (
    <div>
      <div
        style={{
          marginTop: "5em",
          marginBottom: "5em",
        }}
        className="container orderSuccess"
      >
        {state ? (
          <div className="shareForm">
            <img
              style={{
                marginBottom: "1em",
              }}
              src={success}
              alt="Success"
            />
            <p
              style={{
                color: "rgb(99, 50, 53)",
              }}
            >
              {t("payment.success_payment")}
            </p>
            {failType === "order" && (
              <button
                style={{
                  display: "inline-block",
                }}
                onClick={handleProceed}
              >
                {t("payment.track_order")}
              </button>
            )}
          </div>
        ) : (
          <div className="shareForm">
            <img
              style={{
                marginBottom: "1em",
              }}
              src={failed}
              alt="Failed"
            />

            <p
              style={{
                color: "rgb(99, 50, 53)",
              }}
            >
              {t("payment.notSuccess_payment")}
            </p>

            <div
              className="creditCard"
              style={{
                margin: "auto",
                marginTop: "2em",
                maxWidth: "600px",
              }}
            >
              <Frames
                cardValidationChanged={(e) => {
                  setCardValid(e.isValid);
                }}
                config={{
                  publicKey: "pk_sbox_wxn7ld2c4dskxkd4kcpiilwo2uo",
                  schemeChoice: true,
                }}
                cardTokenized={(e) => {
                  payAgain(e.token);
                }}
              >
                <CardNumber />
                <div className="date-and-code">
                  <ExpiryDate />
                  <Cvv />
                </div>
                
                {paymentLoad ? (
                  <div
                    style={{
                      height: "6vh",
                      marginTop: "2em",
                      marginBottom: "1em",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                    className="loader"
                  >
                    <BeatLoader
                      color={"#ffc010"}
                      loading={paymentLoad}
                      size={30}
                    />
                    <p className="paymentLoad">{t("payment.processing")}</p>
                  </div>
                ) : (
                  <button
                    disabled={!cardValid || paymentLoad}
                    id="pay-button"
                    onClick={() => {
                      setPaymentLoad(true);
                      Frames.submitCard();
                    }}
                  >
                    {t("payment.pay_again")}
                  </button>
                )}
              </Frames>
              
              {failType === "order" && (
                <button
                  style={{
                    display: "inline-block",
                    marginTop: "0",
                    width: "100%",
                    textAlign: "center",
                  }}
                  onClick={handleProceed}
                >
                  {t("payment.track_order")}
                </button>
              )}
              
              {errorMsgModel && (
                <span
                  className="errMsg"
                  style={{
                    fontSize: "16px",
                    display: "block",
                    textAlign: "center",
                    marginTop: "10px",
                    color: "#dc3545",
                  }}
                >
                  {i18n.language === "ar" ? msgAr : msgEn}
                </span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default FailedTransaction;